/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer, useParameter, yearToCropYearShort, useDictionaryItem } from "../../shared";
import { CalendarControl } from "./controls/CalendarControl";
import { CommoditiesControl } from "./controls/CommoditiesControl";
import { BusinessUnitControl } from "./controls/BusinessUnitControl";
import { UnitsControl } from "./controls/UnitsControl";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { dictionaryService } from "../../dataFlow";

export default function (props: { exportMode?: boolean }) {
  const { exportMode } = props;
  const [commodities] = useParameter<number[]>("@commodities_display");
  const [business, setBusiness] = useParameter<number>("@business-units");
  const [commName, setCommName] = React.useState("");
  const [commodityItem, commodityName] = useDictionaryItem(dictionaryService, "slides-commodities-display", Number(last(commodities)), {
    business_unit: Number(business),
    slide: 2,
  });

  const description =
    Number(business) === 2
      ? [
          "Showing historical development of Crop Area, Production and Yield",

          "Yield refers to the latest available year",

          "Source: USDA PS&D (Field crops), FAO (Fruits & Vegetables), Global Insight and Eurostat for individual EU countries",

          "Marketing Year: The marketing year starts directly after the crop year. In this period the crop finds it way to the market. E.g. the marketing year 11-12 markets the crops grown in the crop year 10-11",
        ]
      : [
          "Showing historical development of Crop Area, Production and Yield",
          "Yield refers to the latest available year",
          "Source: USDA PS&D (Field crops), FAO (Fruits & Vegetables), Global Insight and Eurostat for individual EU countries",
          "Marketing Year: The marketing year starts directly after the crop year. In this period the crop finds it way to the market. E.g. the marketing year 11-12 markets the crops grown in the crop year 10-11",
        ];
  React.useEffect(() => {
    if (commodityItem && commodityName) {
      setCommName(commodityName[9]);
    }
  }, [commodityItem, commodityName]);
  const [calendar] = useParameter<number[]>("@calendar");
  const [, calendarName] = useDictionaryItem(dictionaryService, "slides-calendar", first(calendar));
  const bname = (business || 1) === 2 ? "APE" : "AP";
  const title = React.useMemo(
    () => `${bname} major crops by lead countries – ${commName} area, production and yield`,
    [commName, business]
  );
  const year = calendarName ? Number(calendarName) : new Date().getFullYear() - 1;
  const usdaSubtitle = `USDA marketing year (eg. ${yearToCropYearShort(year)} = Crop Year ${yearToCropYearShort(year - 1)})`;
  const comment = commodityItem?.getValue<string | null>("comment");
  const subtitle = !comment && comment !== "" ? usdaSubtitle : comment;
  useExportQuery(title, subtitle);
  const { isFavouriteLoading } = useFavourite();
  useSubscription();

  const defaultBusiness = React.useMemo(() => business, []);
  React.useEffect(() => {
    return () => {
      setBusiness(defaultBusiness || null);
    };
  }, []);

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup isLoading={isFavouriteLoading}>
          <BusinessUnitControl />
          <CommoditiesControl key={business || undefined} />
          <CalendarControl />
          <UnitsControl />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={2} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart-area-production-yield" />
          <ReportRenderer componentId="chart-net-trade" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
